module.exports = __webpack_public_path__ + "static/media/mn14.8427ce39.jpeg";